// extracted by mini-css-extract-plugin
export var boldText = "_78-4";
export var checkboxContainer = "_78-6";
export var closeIcon = "_78-i";
export var container = "_78-0";
export var drawer = "_78-8";
export var drawerContent = "_78-9";
export var extraSmallText = "_78-5";
export var fulfillmentGroupTable = "_78-e";
export var largeText = "_78-3";
export var loadingSpinnerContainer = "_78-j";
export var mediumText = "_78-2";
export var narrow = "_78-f";
export var notificationLink = "_78-l";
export var packageCheckIconContainer = "_78-7";
export var slideoutHeaderActions = "_78-g";
export var slideoutHeaderActionsShifted = "_78-h";
export var slideoutHeaderContainer = "_78-a";
export var slideoutModal = "_78-c";
export var stickyHeaderWrapper = "_78-b";
export var table = "_78-k";
export var tableContainer = "_78-d";
export var tertiaryText = "_78-1";